import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-popover-info-icon',
  templateUrl: './popover-info-icon.component.html',
  styleUrls: ['./popover-info-icon.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PopoverInfoIconComponent implements OnInit {
  @Input() helpText: string | null = null;
  @Input() popoverAppendTo: string = 'body';
  @Input() popoverPlacement: string = null;

  constructor() { }

  ngOnInit() {}

}

